import type { IconProps } from './types';

export const UserMinus02Icon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
    >
      <path
        d="M23.25 18.5625H13.875M1.6875 20.5609V14.6116C1.6875 14.6116 4.1875 12.4688 9.1875 12.4688C12.4197 12.4688 14.6072 13.3643 15.75 13.9974M5.43844 5.43656C5.43844 5.9289 5.53541 6.41641 5.72382 6.87127C5.91223 7.32612 6.18838 7.73942 6.53651 8.08755C6.88465 8.43568 7.29794 8.71184 7.7528 8.90024C8.20765 9.08865 8.69517 9.18563 9.1875 9.18563C9.67983 9.18563 10.1673 9.08865 10.6222 8.90024C11.0771 8.71184 11.4904 8.43568 11.8385 8.08755C12.1866 7.73942 12.4628 7.32612 12.6512 6.87127C12.8396 6.41641 12.9366 5.9289 12.9366 5.43656C12.9366 4.44225 12.5416 3.48866 11.8385 2.78557C11.1354 2.08249 10.1818 1.6875 9.1875 1.6875C8.19319 1.6875 7.2396 2.08249 6.53651 2.78557C5.83343 3.48866 5.43844 4.44225 5.43844 5.43656Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
